import React, { useState, useEffect } from "react";
import { componentRoutes } from "shared/utils/routes";
import { Link, useLocation } from "react-router-dom";
import "./index.scss";
import SideBarSiteManager from "pages/Site/pages/SideBarSite/SideBarSiteManager";
import SideBarSettings from "pages/Settings/components/SideBarSettings";
import SideBarStoreManager from "pages/Site/pages/SideBarSite/SideBarStoreManager";

const Sidebar = (props: any) => {
  const location = useLocation();
  const routes = () => {
    if (window.location.pathname.includes("component")) return componentRoutes;
    return [];
  };
  const [currentIndex, setIndex] = useState(
    routes().findIndex((rt) => rt.path == window.location.pathname)
  );
  useEffect(() => {
    setIndex(routes().findIndex((rt) => rt.path == location.pathname));
  }, [location]);
  if (window.location.pathname.includes("sitev2")) {
    return (
      <div id="sidebar">
        <SideBarSiteManager />
      </div>
    );
  }
  if (window.location.pathname.includes("store")) {
    return (
      <div id="sidebar">
        <SideBarStoreManager />
      </div>
    );
  }
  if (window.location.pathname.includes("settings")) {
    return (
      <div id="sidebar">
        <SideBarSettings />
      </div>
    );
  }
  if (routes().length == 0) return <div />;
  return (
    <div id="sidebar">
      <div style={{ display: "flex", flexDirection: "column" }}>
        {routes().map((rt, index) => {
          const className = currentIndex == index ? "selected" : "";
          return (
            <Link className={className} key={rt.path} to={rt.path}>
              {rt.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
